import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default class ShowWinningsState extends BaseState {
    constructor(stateData) {
        super(stateData);
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('winningsController:allWinningsComplete', this.onAllWinningsComplete, this);
    }

    start() {
        super.start();
        // if ((!EntryPoint.AutoPlaySettings.active && !EntryPoint.AutoPlaySettings.paused) && !EntryPoint.GameModel.isFreeSpinsMode && !EntryPoint.GameModel.isBigWin) {
        if (!EntryPoint.GameModel.winnings.scatters) this.complete();
        // }
    }

    onAllWinningsComplete() {
        if (this.active) {
            this.complete();
        }
    }
}
